export default __webpack_public_path__ + "static/2-d60a47c76bc3f95bb96e509a7ce97c37.jpeg";